// extracted by mini-css-extract-plugin
module.exports = {"wrpr":"AdSidebar_wrpr__JQgg1","ad1":"AdSidebar_ad1__yVGNS","ad2":"AdSidebar_ad2__fAXLv"};